
const InternalAppDashboardWidgetType = {
  Notifications: 1,
  Messages: 2,
  Tasks: 3,
  SubmittedReportGroups: 4
}

export {
  InternalAppDashboardWidgetType
}



// WEBPACK FOOTER //
// ./src/enums/InternalAppDashboardWidgetType.js